var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _path, _path2, _path3, _circle, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 510.9,
    height: 510.9,
    viewBox: "-4.1 -4.1 510.9 510.9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#000000",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    x1: 34.259,
    y1: 248.288,
    x2: 474.365,
    y2: 248.288,
    gradientUnits: "userSpaceOnUse",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#1CDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964,
    stopColor: "#AA81F3"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    x1: 28.235,
    y1: 248.288,
    x2: 468.341,
    y2: 248.288,
    gradientUnits: "userSpaceOnUse",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#1CDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964,
    stopColor: "#AA81F3"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 251.3,
    x2: 502.6,
    y2: 251.3,
    gradientUnits: "userSpaceOnUse",
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#AA81F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F54EA2"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    x1: 178.942,
    y1: 251.3,
    x2: 314.679,
    y2: 251.3,
    gradientUnits: "userSpaceOnUse",
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#AA81F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F54EA2"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    x1: 34.259,
    y1: 254.312,
    x2: 474.365,
    y2: 254.312,
    gradientUnits: "userSpaceOnUse",
    id: "e"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#1CDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964,
    stopColor: "#AA81F3"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    x1: 28.235,
    y1: 254.312,
    x2: 468.341,
    y2: 254.312,
    gradientUnits: "userSpaceOnUse",
    id: "f"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#1CDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964,
    stopColor: "#AA81F3"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: " M 44.2591 44.2591 C 71.928 16.5901 187.053 86.8553 301.399 201.201 C 415.744 315.546 486.009 430.672 458.341 458.341",
    stroke: "url(#a)",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: " M 44.2591 458.341 C 16.5901 430.672 86.8553 315.546 201.201 201.201 C 315.546 86.8553 430.672 16.5901 458.341 44.2591",
    stroke: "url(#b)",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: " M 80.675 80.675 L 421.924 80.675 L 421.924 421.924 L 80.675 421.924 Z",
    stroke: "url(#c)",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    transform: "matrix(0.707107,0.707107,-0.707107,0.707107,251.3,-104.092)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 251.3,
    cy: 251.3,
    r: 35.458,
    fill: "url(#d)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: " M 458.341 44.2591 C 486.009 71.928 415.744 187.053 301.399 301.399 C 187.053 415.744 71.928 486.009 44.2591 458.341",
    stroke: "url(#e)",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: " M 458.341 458.341 C 430.672 486.009 315.546 415.744 201.201 301.399 C 86.8553 187.053 16.5901 71.928 44.2591 44.2591",
    stroke: "url(#f)",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.2e4e99dbc4ac6044127f47fb14da6120.svg";
export { ForwardRef as ReactComponent };